/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle02Icon16Light } from './NumberCircle02Icon16Light';
import { NumberCircle02Icon16Regular } from './NumberCircle02Icon16Regular';
import { NumberCircle02Icon16Solid } from './NumberCircle02Icon16Solid';
import { NumberCircle02Icon20Light } from './NumberCircle02Icon20Light';
import { NumberCircle02Icon20Regular } from './NumberCircle02Icon20Regular';
import { NumberCircle02Icon20Solid } from './NumberCircle02Icon20Solid';
import { NumberCircle02Icon24Regular } from './NumberCircle02Icon24Regular';
import { NumberCircle02Icon24Solid } from './NumberCircle02Icon24Solid';
import { NumberCircle02Icon32Regular } from './NumberCircle02Icon32Regular';
import { NumberCircle02Icon64Regular } from './NumberCircle02Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle02Icon16Light,
        regular: NumberCircle02Icon16Regular,
        solid: NumberCircle02Icon16Solid,
    },
    20: {
        light: NumberCircle02Icon20Light,
        regular: NumberCircle02Icon20Regular,
        solid: NumberCircle02Icon20Solid,
    },
    24: {
        regular: NumberCircle02Icon24Regular,
        solid: NumberCircle02Icon24Solid,
    },
    32: {
        regular: NumberCircle02Icon32Regular,
    },
    64: {
        regular: NumberCircle02Icon64Regular,
    },
};
export var NumberCircle02Icon = forwardRef('NumberCircle02Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
